export const styles = {
	popperFont: {
		color: 'black',
		fontSize: '12px',
	},
}
